import { Box, Button } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import './About.css'
import Education from './Education'
import Experience from './Experience'
import MainAbout from './MainAbout'

const About = () => {
  return (
    <Box className='about-page' component='article'>
      <header className='about-hero'>
        <Box className='about-hero__photo' aria-hidden='true' />
        <Box className='about-hero__overlay' aria-hidden='true' />
        <Box className='about-hero__content'>
          <p className='about-hero__eyebrow'>About</p>
          <h1 className='about-hero__title'>Catherine Hall</h1>
          <p className='about-hero__subtitle'>
            Classical violin · Irish fiddle · Musicology · Teaching
          </p>
        </Box>
      </header>

      <Box className='about-main' component='main'>
        <MainAbout />
        <Education />
        <Experience />

        <Box className='about-cta'>
          <p className='about-cta__text'>Interested in lessons, performances, or collaboration?</p>
          <Button
            component={RouterLink}
            to='/contact'
            variant='contained'
            color='primary'
            size='large'
            sx={{ px: 4, py: 1.25 }}
          >
            Get in Touch
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default About
